
//
// Reasons for files to be rejected
//
export enum RejectionReasons {
    None,

    FileType,
    FileSize,

    Unknown,
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/ng2-file-drop/properties/rejection-reasons.ts